
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { StartChallengeForm } from "./StartChallengeForm";
import { PropBot } from "@/types/prop-bots";
import { useTranslation } from "react-i18next";

interface StartChallengeDialogProps {
  bot: PropBot;
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  defaultReversePosition?: boolean;
}

export const StartChallengeDialog = ({
  bot,
  isOpen,
  onClose,
  onSuccess,
  defaultReversePosition,
}: StartChallengeDialogProps) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onClose();
    onSuccess?.();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{t('start_challenge_with_bot', { botName: bot.name })}</DialogTitle>
        </DialogHeader>
        <StartChallengeForm bot={bot} onSuccess={handleSuccess} defaultReversePosition={defaultReversePosition} />
      </DialogContent>
    </Dialog>
  );
};
